import { Injectable, inject } from '@angular/core';
import { ILSystem, TeilbetragsUebersicht } from '@mwe/models';
import { MemoryCacheService, MemoryCacheItem } from '../../cache/memory-cache.service';
import { AdvancedPaymentPlanService } from '../../advanced-payment-plan/advanced-payment-plan.service';

@Injectable({ providedIn: 'root' })
export class InteractiveInvoicePartsLogic {
  private memoryCacheService = inject(MemoryCacheService);
  private advancedPaymentPlanService = inject(AdvancedPaymentPlanService);

  async getInvoiceParts(systemId: ILSystem, accountId: string): Promise<TeilbetragsUebersicht> {
    if (this.memoryCacheService.has(MemoryCacheItem.InvoiceParts, systemId, accountId)) {
      return this.memoryCacheService.get(MemoryCacheItem.InvoiceParts, systemId, accountId);
    }

    const response = await this.advancedPaymentPlanService.getAdvancedPaymentPlanDetails(systemId, accountId);
    if (!response?.abschlagsplaene) {
      return null;
    }

    const planDetails = response.abschlagsplaene[0];
    const invoiceParts = { teilbetraege: planDetails.teilbetraege } as TeilbetragsUebersicht;
    this.memoryCacheService.set(MemoryCacheItem.InvoiceParts, invoiceParts, systemId, accountId);
    return invoiceParts;
  }
}
